export type Limits = {
  x: [number, number]
  y: [number, number]
}

export const combineLimits = (limits: Limits[]): Limits => ({
  x: [Math.min(...limits.map((l) => l.x[0])), Math.max(...limits.map((l) => l.x[1]))],
  y: [Math.min(...limits.map((l) => l.y[0])), Math.max(...limits.map((l) => l.y[1]))]
})

const calculateLimits = (values: number[]): [number, number] => [
  Math.min(...values),
  Math.max(...values)
]

export const calculateLimitsFromValues = (
  xValues: number[],
  yValues: (number | null)[]
): Limits => ({
  x: calculateLimits(xValues),
  y: calculateLimits(yValues.filter((v) => v !== null) as number[])
})
